var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    transform: "matrix(-1 0 0 1 32 0)",
    fill: "#0066B0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12980_22656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7275 9.9993V21.4737C16.7275 21.778 16.8498 22.0698 17.0676 22.285C17.2853 22.5002 17.5805 22.6211 17.8884 22.6211L20.2102 22.6211C20.5181 22.6211 20.8133 22.5002 21.0311 22.285C21.2488 22.0698 21.3711 21.778 21.3711 21.4737V9.9993C21.3711 9.69498 21.2488 9.40313 21.0311 9.18794C20.8133 8.97275 20.5181 8.85186 20.2102 8.85186L17.8884 8.85186C17.5805 8.85186 17.2853 8.97275 17.0676 9.18794C16.8498 9.40313 16.7275 9.69498 16.7275 9.9993ZM20.2102 9.9993V21.4737L17.8884 21.4737V9.9993L20.2102 9.9993Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66236 15.1628L11.1634 13.6791L10.3426 12.8679L7.44043 15.7365L10.3426 18.6051L11.1634 17.7938L9.66236 16.3102L13.2448 16.3102V22.6211L14.4057 22.6211V8.85186L13.2448 8.85186V15.1628L9.66236 15.1628Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12980_22656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.359,
    height: 18.5741,
    fill: "white",
    transform: "translate(5.11865 24.916) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandBlue);
export default __webpack_public_path__ + "static/media/ExpandBlue.7feb7051e8a7a1bd00145f78532d95a0.svg";
export { ForwardRef as ReactComponent };